export const slugify = (text) => {
  return text
    .normalize("NFD") // Décompose les accents
    .replace(/[\u0300-\u036f]/g, "") // Supprime les accents
    .toLowerCase()
    .replace(/\s+/g, '-') // Remplace les espaces par des tirets
    .replace(/[^a-z0-9-]/g, '') // Supprime tout le reste sauf lettres, chiffres et tirets
    .replace(/--+/g, '-') // Supprime les tirets consécutifs
    .replace(/^-+|-+$/g, ''); // Supprime les tirets au début et à la fin
};
